module.exports = __webpack_public_path__ + "static/media/image_logo_dian_color.d81660d8.png";